import FunnelHeader from '@/components/v1/FunnelHeader'
import FunnelLayout from '@/components/v1/FunnelLayout'
import StickyFooter from '@/components/v1/StickyFooter'
import { FUNNEL_PROGRESS_SECTIONS } from '@/pages/v1/onboarding/funnelSteps'
import appStoreAppOfTheYear2023 from '@app-studio-web/ui/assets/app_store_app_of_the_day_2023.webp'
import googleEditorsChoice2023 from '@app-studio-web/ui/assets/google_editors_choice_2023.webp'
import { StarIcon } from '@heroicons/react/24/solid'
import { Trans, useTranslation } from 'react-i18next'
import { Form, useNavigate } from 'react-router-dom'

const STARS = [0, 1, 2, 3, 4]

/**
 * li-funnel-redesign v1 — the editorial take on the shared sign-up intro. Same
 * single action (continue to the password step), restyled to match the funnel.
 */
export default function CompanyPage() {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    navigate('/sign-up/password')
  }

  return (
    <FunnelLayout
      header={
        <FunnelHeader
          section="yourAccount"
          sectionProgress={1 / 3}
          sections={FUNNEL_PROGRESS_SECTIONS}
        />
      }
    >
      <div className="flex grow flex-col gap-5 pt-1">
        <h1 className="hw-heading animate-fade-up text-left!">
          {t('pages.signUp.company.heading')}
        </h1>

        <div className="hw-card animate-fade-up space-y-5 p-5 [animation-delay:120ms]">
          <div className="flex items-center justify-center gap-4">
            <img
              alt={t('pages.signUp.company.appStoreAppOfTheYear2023')}
              className="w-32"
              src={appStoreAppOfTheYear2023}
            />

            <img
              alt={t('pages.signUp.company.googleEditorsChoice2023')}
              className="w-32"
              src={googleEditorsChoice2023}
            />
          </div>

          <div className="border-hw-line space-y-1 border-t pt-4 text-center">
            <p className="text-hw-muted text-sm">
              {t('pages.signUp.company.andHas')}
            </p>

            <p className="text-hw-ink text-xl font-extrabold">
              <Trans
                components={{ colored: <span className="text-hw-primary" /> }}
                i18nKey="pages.signUp.company.activeSubscribers"
              />
            </p>

            <div className="flex justify-center pt-1">
              {STARS.map((star) => (
                <StarIcon className="text-hw-yellow h-5 w-5" key={star} />
              ))}
            </div>
          </div>
        </div>

        <Form
          className="flex grow flex-col"
          method="post"
          onSubmit={handleSubmit}
        >
          <StickyFooter>
            <button
              className="hw-button-primary"
              data-testid="button-continue"
              type="submit"
            >
              {t('shared.continue')}
            </button>
          </StickyFooter>
        </Form>
      </div>
    </FunnelLayout>
  )
}
